import React from 'react';

import {Input} from 'reactstrap';

import SearchInput from 'components/SearchInput';
import DualSelectItem from 'components/DualSelect/DualSelectItem';


const DualSelectBoxContainer = (props) => {
    const {list, handleItemSelect, selected, source, handleSearchFilter, handleClearSearch, handleSortDirection, searchValue, contentType, handleViewTypeChange, sortDirection, hideGroups} = props;

    return (
        <div className="dual-select__box-container dual-select__box-container--left">
            <div className="dual-select__options">
                <SearchInput
                    onClear={() => handleClearSearch(source)}
                    onChange={handleSearchFilter}
                    placeholder="Filter by name"
                    value={searchValue}
                    extraParams={source}
                />
                <div className="d-flex" style={{width: '25%', marginLeft: 0}}>
                    <Input
                        type="select"
                        name="sortDirection"
                        className="dual-select__direction"
                        value={sortDirection}
                        onChange={(e) => handleSortDirection(e.target.value)}
                    >
                        <option value="asc">{window.innerWidth > 640 ? 'Name(A-Z)' : 'A-Z'}</option>
                        <option value="desc">{window.innerWidth > 640 ? 'Name(Z-A)' : 'Z-A'}</option>
                    </Input>
                </div>
            </div>
            <div className="dual-select__box">
                {list.map(item => (
                    <DualSelectItem
                        key={item.id}
                        item={item}
                        selectedItems={selected}
                        handleItemSelect={handleItemSelect}
                        source={source}/>
                ))}
            </div>
        </div>
    );
};

export default DualSelectBoxContainer;
